import Base from 'netxcore@netx/core-app/views/confirmView';

import {faExternalLinkAlt} from '@fortawesome/pro-solid-svg-icons';
const icons = Base.initializeIcons({
	faExternalLinkAlt,
});

export default class ConfirmView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.icons = {...icons, ...opts.icons};
		super(opts);
	}
}
